@if (activities?.length) {
	<cjm-tag-group>
		@for (activity of activities; track activity) {
			<li>
				<cjm-tag icon="fa-person" tagType="yellow">{{ activity.name }}</cjm-tag>
			</li>
		}
	</cjm-tag-group>
}
